module.exports = __webpack_public_path__ + "media/images/new_culture/bg-7-05ee60e5fc35c701ce247d4b86264674.jpeg";